import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const SearchBarWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  position: sticky;
  top: 0;
  z-index: 1;
  padding: ${theme.spacing.xSmall}px;

  .search-icon {
    position: absolute;
    left: 26px;
    top: 18px;
    z-index: 1;

    /* SearchSmallIcon bakes fill=#d0c3cc; a CSS fill property beats the attribute. */
    html[data-theme='light'] & {
      svg path {
        fill: ${theme.colors.devicesSecondaryText};
      }
    }
  }

  .clear-btn {
    position: absolute;
    right: ${theme.spacing.lg}px;
  }

  .search-bar {
    width: 100%;
    border-radius: ${theme.attributes.borderRadius.secondary};
    height: 36px;
  }

  .MuiOutlinedInput-input {
    border: 1px solid ${theme.colors.legacy261f25};
    border-radius: ${theme.attributes.borderRadius.secondary};
    background: ${theme.colors.legacy261f252};
    height: 36px;
    padding: 0 48px;
    color: ${theme.colors.btnSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;

    &::placeholder {
      color: ${theme.colorTokens.text.textSecondary};
      opacity: 1;
    }

    &:focus {
      border-color: ${theme.colors.cta};
    }

    html[data-theme='light'] & {
      color: ${theme.colors.devicesSecondaryText};
      font-weight: ${theme.typography.fontWeight.normal};
      background: ${theme.colors.cardFillTertiary};
      border-color: transparent;

      &::placeholder {
        color: ${theme.colors.devicesSecondaryText};
      }

      &:focus {
        background: ${theme.colors.surfaceContainerBackground};
        border-color: ${theme.colors.cta};

        &::placeholder {
          color: ${theme.colors.devicesSecondaryText};
        }
      }
    }
  }

  fieldset {
    border: none;
  }
`
